// constants
import { ESTIMATE_INDUCE_REFRESH_PARAMETER_LIST_NAME_FOR_USER } from "../../../constants/booking";

/**
 * Retourne vrai si le paramètre couramment modifié va potentiellement
 *   modifier l'estimation.
 * @param {object} parameterName
 * @return {boolean}
 */
export default function mayEstimateBeRefresh({ parameterName }) {
  return ESTIMATE_INDUCE_REFRESH_PARAMETER_LIST_NAME_FOR_USER.includes(
    parameterName
  );
}
